/** Available filters */
export enum FilterCacheKey {
  REPORT_ACCOUNTS_RECEIVABLE = 'report.accounts-receivable',
  CLIENTS = 'clients',
  REPORT_ACCOUNTS_PAYABLE_DYNAMICS = 'report.accounts-payable-dynamics',
  NEWSLETTER = 'newsletter',
  NEWSLETTER_TEMPLATE = 'newsletter.template',
  REPORT_CASH_GAP = 'report.cash-gap',
  DEAL = 'deal',
  DIRECTIONS = 'directions',
  REPORT_AUTOCHECK_DOCUMENTS = 'report.autocheck-documents',
  PROJECT_TEMPLATES = 'project-templates',
  ACTIVITY = 'activity',
  USERS = 'users',
  USER_GROUP_LIST = 'user-group.list',
  ROLE_LIST = 'role.list',
  WORK_SCHEDULE_LIST = 'work-schedule.list',
  PROJECT_TIME_REPORT = 'project.time.report',
  REPORT_HELPDESK_TASKS = 'report.helpdesk.tasks',
  HELP_DESK_TASK = 'help-desk.task',
  HELPDESK_TEMPLATES = 'helpdesk-templates',
  CONTRAGENTS = 'contragents',
  REPORT_AUTOCHECK_BILL = 'report.autocheck-bill',
  REPORT_PAYMENT_CALENDAR = 'report.payment-calendar',
  REPORT_PAYMENT_OUTGOING = 'report.payment-outgoing',
  PLANNED_INCOME = 'planned-income',
  DOCUMENT_TEMPLATE = 'document-template',
  PROJECTS = 'projects',
  REPORT_DEBTORS = 'report.debtors',
  PLAN_FACT_BUDGET_TASK = 'plan-fact.budget.task',
  REPORT_DOCUMENT_VERIFY_COMPARE = 'report.document-verify-compare',
  REPORT_EVENT_CALENDAR = 'report.event-calendar',
  REPORT_ACCOUNTS_PAYABLE = 'report.accounts-payable',
  TASK_TEMPLATES = 'task-templates',
  PAYMENTS_TASK = 'payments.task',
  PAYMENT_STATUS_LIST = 'payment-status.list',
  COMPANIES = 'companies',
  CONNECTION_1C_LIST = 'connection-1c.list',
  TENANT_LIST = 'tenant-list',
  RATE_PLAN_LIST = 'rate-plan-list',
  REPORT_ACCOUNTS_RECEIVABLE_DYNAMICS = 'report.accounts-receivable-dynamics',
  PURCHASE_REPORT = 'report.purchase',
  PURCHASE_ACTUAL_LIST = 'list.purchase-actual',
  REPORT_ABC_ANALYSIS = 'report.abc-analysis',
  REPORT_BRS_DDS = 'report.dds',
  EXCLUSION = 'report.exclusion',
  DOCUMENTS = 'report.documents',
  REPORT_BALANCE = 'report.balance',
  REPORT_BALANCE_INCOME_STATEMENT = 'report.balance-income-statement',
  REPORT_BALANCE_CASH_FLOW = 'report.balance-cash-flow',
  UNITS = 'units',
  FILIALS = 'filials',
  MASTER_MILESTONES = 'master-milestones',
  DOCUMENT_TYPES = 'document-types',
  APPROVAL_SCHEMES = 'approval-schemes',
  CONTRACTS = 'contracts',
  BANNERS = 'banners.list',
  ROOMS = 'rooms',
  SALARY_DISTRIBUTION = 'salary-distribution',
  SALARY_ACCRUAL = 'salary-accrual',
  NOMENCLATURES = 'nomenclatures',
  BILL_REGISTRY = 'bill-registry',
  EQUIPMENTS = 'equipments',
  CASH_REGISTER = 'report.cash-register',
  CASH_REGISTER_ACTIVITY = 'cash-register-activity',
  RECEIPT_REPORT = 'report.receipt',
  BALANCE_SHEET_REPORT = 'report.balance-sheet',
  CONTROL_EVENT_REPORT = 'control.event.report',
  CONTROL_COMING_GOING_REPORT = 'control.coming-going.report',
  CONTROL_PHOTO_VERIFICATION = 'control.photo-verification',
  CONTROL_ACCESS_CARD = 'control.access-card.report',
  HELP_DESK_TASK_TYPE = 'helpdesk.task-type',
  HELP_DESK_EAV_ENTITY_TYPE = 'helpdesk.eav-entity-type.list',
  TYPE_OF_ACTIVITY = 'type-of-activity',
  UNREAD_NOTIFICATIONS = 'report.unread-notifications',
  LK_EU_HELP_DESK_TASK = 'lk.eu.help-desk.task',
  LK_EU_TRANSIT_TASK = 'lk.eu.transit.task',
  LK_EU_RESIDENT_CAR = 'lk.eu.resident-car.list',
  LK_EU_PASSAGE_TASK = 'lk.eu.passage-task.list',
  LK_EU_PASSAGE_ORDER = 'lk.eu.passage-order.list',
  LK_EU_EXTERNAL_USERS = 'lk.eu.external-users.list',
  COST_CENTRAL = 'cost-central',
  EXTERNAL_USERS = 'external-users',
  ACCOUNTING_ACCOUNT = 'accounting-account',
  PLANNING_SCENARIO = 'planning-scenario',
  TRAFFIC_ADAPTER = 'traffic-adapter',
  TRAFFIC_REPORT = 'report.traffic',
  EXCHANGE_LOG = 'integration.exchange-log',
  KBK = 'kbk.list',
  PAYER_STATUS = 'payer-status.list',
  REVENUE_ADMIN = 'revenue-admin.list',
  CURRENCY = 'currency.list',
  TASK_SCENARIO = 'payment-task-scenario.list',
  OPERATION_TYPES = 'operation-types.list',
  PASSAGE_EVENT_REPORT = 'report.passage-event',
  TRANSIT_TASK = 'transit-task.list',
  RESIDENT_CAR = 'resident-car.list',
  PASSAGE_TASK = 'passage-task.list',
  PASSAGE_ORDER = 'passage-order.list',
  REPORT_VISITORS = 'report.visitors',
  BULL_MQ_JOB_HISTORY = 'bull-mq-job-history.list',
  NET_PING_DEVICES = 'net-ping-devices.list',
  ANALYTICS_RESET = 'analytics-reset.list',
  HIKVISION_CAMERAS = 'hikvision-cameras.list',
  ADMIN_STORAGE_STORAGES = 'admin-storage-storages.list',
  ADMIN_STORAGE_BUCKETS = 'admin-storage-buckets.list',
  ADMIN_STORAGE_FILES = 'admin-storage-files.list',
  ADMIN_BUGTRACKER_ERROR_ENTRIES = 'admin-bugtracker-error-entries.list',
  ADMIN_PLUGIN_1C = 'admin-plugin-1c.list',
  AI_AGENT = 'ai-agent.list',
  AI_KNOWLEDGE_BASE = 'ai-knowledge-base.list',
  DOCUMENT_FILE_TEMPLATE = 'document-file-template.list',
  DEBTS_DEBT_COLLECTION_TASK = 'debts.debt-collection-task.list',
  DEAL_TYPE = 'deal-type.list',
  DEAL_STATUS_LIST = 'deal-status.list',
  REPORT_RENTAL_RATE = 'report.rental-rate.list',
  DOCUMENT_BANK_STATEMENT_RULE_LIST = 'document.bank-statement-rule.list',
  CATALOG_OTHER_FINANCIAL_FLOW_LIST = 'catalog.other-financial-flow.list',
}
